import React, { ReactElement, ReactNode, useState, useEffect } from 'react';
import { usePopper } from 'react-popper';
import { MentionPluginStore, PopperOptions } from '../mentionsPlugin';

interface PopoverProps {
  store: MentionPluginStore;
  children: ReactNode;
  popperOptions?: PopperOptions;
}

export default function Popover({
  store,
  children,
  popperOptions = { placement: 'bottom-start' },
}: PopoverProps): ReactElement {
  const [className, setClassName] = useState('mentionSuggestions mentionSuggestionsPopup');
  const [popperElement, setPopperElement] = useState<HTMLElement | null>(null);

  const { styles, attributes } = usePopper(store.getReferenceElement(), popperElement, popperOptions);

  useEffect(() => {
    requestAnimationFrame(() =>
      setClassName('mentionSuggestions mentionSuggestionsPopup mentionSuggestionsPopupVisible')
    );
  }, []);

  return (
    <div ref={setPopperElement} style={styles.popper} {...attributes.popper} className={className}>
      {children}
    </div>
  );
}
